import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";

import * as prizeActions from "../prize.actions";
import { getAllPrizesSorted } from "../prize.selectors";

import Table from "../../common/components/Table";
import Button from "../../../ui/button/Button";

import { Localize } from "../../../locale/localization";
import TableHeader from "../../common/components/TableHeader";
import { sortTableAndHead } from "../../../utils/content-utils";

class PrizeListContainer extends Component {
  state = {
    sortedData: [],
    tableHead: [
      { name: "price", uiName: Localize("score.unit") },
      { name: "name", uiName: Localize("name") },
      { name: "type", uiName: Localize("type") },
      { name: "description", uiName: Localize("description") }
    ]
  };

  componentWillMount() {
    this.updateSortData(this.props.prizes);
  }

  componentWillReceiveProps(nextProps) {
    this.updateSortData(nextProps.prizes);
  }

  updateSortData = content => {
    this.setState(
      Object.assign({}, this.state, {
        sortedData: content ? content : []
      })
    );
  };

  sortTable = headItem => {
    const sorted = sortTableAndHead(headItem, this.state.tableHead, this.state.sortedData);

    this.setState(
      Object.assign({}, this.state, {
        sortedData: sorted.data,
        tableHead: sorted.head
      })
    );
  };

  componentWillMount = () => {
    const { getPrizes } = this.props;
    getPrizes();
  };

  renderPrizeRow = prize => {
    const { _id, name, price, type, description } = prize;

    return (
      <tr key={_id}>
        <td>{price}</td>
        <td>{name}</td>
        <td>{type}</td>
        <td>{description}</td>
        <td>
          <NavLink to={`/admin/prizes/edit/${_id}`}>Muokkaa</NavLink>
        </td>
      </tr>
    );
  };

  renderTableHeader = () => {
    return (
      <TableHeader
        items={this.state.tableHead}
        onSort={this.sortTable}
        sortable={this.state.sortedData.length > 1}
      />
    );
  };

  render() {
    const prizes = this.state.sortedData;
    return (
      <div>
        {prizes && prizes.length > 0 ? (
          <Table
            items={prizes}
            renderHeader={this.renderTableHeader}
            renderItem={this.renderPrizeRow}
          />
        ) : (
          <p>Ei vielä yhtään palkintoa.</p>
        )}
        <footer>
          <NavLink to="/admin/prizes/add">
            <Button theme="text" icon="#plus">
              Lisää palkinto
            </Button>
          </NavLink>
        </footer>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const prizes = getAllPrizesSorted(state);
  return {
    prizes
  };
};

const ConnectedPrizeListContainer = connect(mapStateToProps, Object.assign({}, prizeActions))(
  PrizeListContainer
);

export default ConnectedPrizeListContainer;



// WEBPACK FOOTER //
// ./src/modules/prize/components/PrizeListContainer.js